export default "__VITE_ASSET__D5szRm_u__"